module.exports = __webpack_public_path__ + "assets/img/icon2.8a6b5063.svg";